<template>
	<div class="square-skeleton" aria-hidden="true">
		<section v-for="section in 3" :key="section" class="square-skeleton__section">
			<div class="square-skeleton__head">
				<span class="square-skeleton__title"></span>
				<span class="square-skeleton__button"></span>
			</div>
			<div class="square-skeleton__grid">
				<div v-for="card in 4" :key="card" class="square-skeleton__card">
					<span class="square-skeleton__cover"></span>
					<span class="square-skeleton__line square-skeleton__line--wide"></span>
					<span class="square-skeleton__line square-skeleton__line--short"></span>
				</div>
			</div>
		</section>
	</div>
</template>

<style lang="scss" scoped>
.square-skeleton {
	padding-top: 30px;

	&__section {
		margin-bottom: 100px;
		padding: 30px;
		border-radius: 20px;
		box-shadow: 0 4px 24.6px rgba(0, 0, 0, 0.1);
		background: #ffffff;
	}

	&__head {
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-bottom: 30px;
	}

	&__title,
	&__button,
	&__cover,
	&__line {
		display: block;
		background: linear-gradient(90deg, #f2f2f2 25%, #fafafa 40%, #f2f2f2 60%);
		background-size: 300% 100%;
		animation: square-skeleton-shimmer 1.4s ease-in-out infinite;
	}

	&__title {
		width: 120px;
		height: 34px;
		border-radius: 7px;
	}

	&__button {
		width: 104px;
		height: 32px;
		border-radius: 8px;
	}

	&__grid {
		display: grid;
		grid-template-columns: repeat(4, minmax(0, 1fr));
		gap: 16px;
	}

	&__card {
		padding-bottom: 18px;
		overflow: hidden;
		border: 1px solid #efefef;
		border-radius: 10px;
	}

	&__cover {
		width: 100%;
		aspect-ratio: 47 / 38;
	}

	&__line {
		height: 16px;
		margin: 14px 12px 0;
		border-radius: 4px;

		&--wide {
			width: 72%;
		}

		&--short {
			width: 46%;
			height: 12px;
		}
	}
}

@keyframes square-skeleton-shimmer {
	0% {
		background-position: 100% 0;
	}
	100% {
		background-position: 0 0;
	}
}

@media (prefers-reduced-motion: reduce) {
	.square-skeleton__title,
	.square-skeleton__button,
	.square-skeleton__cover,
	.square-skeleton__line {
		animation: none;
	}
}
</style>
